'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

/**
 * DropdownItem component, used to display an item in the Dropdown. Used within a DropdownList.
 *
 * @example
 * <Dropdown>
 *  <DropdownList>
 *    <DropdownItem>
 *      <DropdownButton>Button</DropdownButton>
 *    </DropdownItem>
 *  </DropdownList>
 * </Dropdown>
 */
const DropdownItem = forwardRef(function DropdownItem(rest, ref) {
    return jsx("li", { ref: ref, ...rest });
});

export { DropdownItem };
